import { useSortInboxQueue } from '@/hooks/queries/useSortInbox';

/**
 * Derives the `(N)` count on the "Close the period" primary nav tab.
 *
 * `N` is the REAL actionable count — `totalInPeriod`, the number of items
 * needing triage in the open reporting period. On a tab literally named "Close
 * the period," the number reads as "things to close," so the badge tracks the
 * inbox the treasurer actually works, not the upcoming-deadline
 * (`useObligations`) count it used to fold over (which read a constant "(2)"
 * even at "Inbox clear").
 *
 * ADR-026 (PR-A): the scalar rides the bounded NeedsAction WORK feed
 * (`useSortInboxQueue`), which carries the identical `totalInPeriod` envelope
 * scalar, rather than the display query that a later PR paginates — so the badge
 * stays correct after the display ledger is paged and can no longer be trusted
 * to hold the whole ledger.
 *
 * Returns 0 while the feed query is in flight (no data yet) and when the
 * inbox is clear, so the render boundary omits the parenthetical rather than
 * showing a stale or speculative number.
 *
 * Refresh: the feed declares its reads, so every triage write's write set refreshes it and the
 * badge drops in lockstep with the inbox.
 */
export function useCloseNavBadge(): number {
  const queue = useSortInboxQueue(undefined);
  return queue.status === 'ready' ? queue.data.totalInPeriod : 0;
}
